import React, { useEffect, useState } from 'react';
import { Loader, Modal } from 'rsuite';
import * as modal from './document-modal-styles';
import { toaster } from '@/utils/toaster';

function DocumentModalComponent(props) {
  const { title, iframeTitle, show, onHide, docLink, docLinkPromise } = props;

  const [documentUrlToLoad, setDocumentUrlToLoad] = useState();

  useEffect(() => {
    (async () => {
      if (docLinkPromise) {
        try {
          const url = await docLinkPromise;
          setDocumentUrlToLoad(url);
        } catch (e) {
          toaster.error('Failed to open document');
          onHide();
        }
      } else {
        setDocumentUrlToLoad(docLink);
      }
    })();
  }, [docLinkPromise, docLink, onHide]);

  return (
    <Modal overflow size="lg" open={show} onClose={onHide}>
      <Modal.Header>
        <modal.Title>{title}</modal.Title>
      </Modal.Header>

      <Modal.Body>
        {documentUrlToLoad ? (
          <modal.Iframe
            id="doc-iframe"
            src={documentUrlToLoad}
            title={iframeTitle}
          />
        ) : (
          <modal.LoaderWrapper>
            <Loader size="lg" />
          </modal.LoaderWrapper>
        )}
      </Modal.Body>
    </Modal>
  );
}

export const DocumentModal = React.memo(DocumentModalComponent);
